var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1874 23.2292C6.45825 23.2292 1.77075 18.5417 1.77075 12.8125C1.77075 12.3959 1.77075 11.875 1.87492 11.4584C1.97909 11.1459 2.18742 11.0417 2.49992 11.0417C2.81242 11.1459 2.91659 11.3542 2.91659 11.6667C2.81242 11.9792 2.81242 12.3959 2.81242 12.8125C2.81242 18.0209 6.97909 22.1875 12.1874 22.1875C17.3958 22.1875 21.5624 18.0209 21.5624 12.8125C21.5624 7.60421 17.3958 3.43754 12.1874 3.43754C11.5624 3.43754 11.0416 3.54171 10.4166 3.64587C10.1041 3.64587 9.89575 3.54171 9.79159 3.22921C9.79159 2.91671 9.89575 2.70837 10.2083 2.60421C10.8333 2.50004 11.4583 2.39587 12.1874 2.39587C17.9166 2.39587 22.6041 7.08337 22.6041 12.8125C22.6041 18.5417 17.9166 23.2292 12.1874 23.2292Z",
    fill: "#D1F27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9167 10.2083H2.70837C2.50004 10.1041 2.2917 9.79163 2.39587 9.47913C3.43754 6.56246 5.52087 4.27079 8.2292 3.22913C8.5417 3.12496 8.75004 3.22913 8.8542 3.54163C8.95837 3.85413 8.8542 4.06246 8.5417 4.16663C6.25004 5.20829 4.27087 7.29163 3.43754 9.89579C3.33337 10.1041 3.12504 10.2083 2.9167 10.2083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.0417C11.5625 16.0417 11.3542 16.0417 11.25 15.9375C11.0417 15.7292 11.0417 15.4167 11.25 15.2083L16.4583 10C16.6667 9.79167 16.9792 9.79167 17.1875 10C17.3958 10.2083 17.3958 10.5208 17.1875 10.7292L11.9792 15.9375C11.9792 16.0417 11.7708 16.0417 11.6667 16.0417Z",
    fill: "#D1F27A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 16.0416C11.5624 16.0416 11.3541 16.0416 11.2499 15.9375L8.95825 13.6458C8.74992 13.4375 8.74992 13.125 8.95825 12.9166C9.16659 12.7083 9.47909 12.7083 9.68742 12.9166L11.9791 15.2083C12.1874 15.4166 12.1874 15.7291 11.9791 15.9375C11.9791 16.0416 11.7708 16.0416 11.6666 16.0416Z",
    fill: "#D1F27A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.30400cf0d5a0e18c465da34f4844e46c.svg";
export { ForwardRef as ReactComponent };